import React from 'react'
import styles from '../menu.scss'
// import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import emptyMessageModal from 'src/assets/icons/empty_message_modal.jpg'
import Button from 'src/components/common/Button'

export class ChatPanel extends React.Component {
  render () {
    /* const CHAT_COLLECTION = [
      { name: 'College Choir Bois', message: 'Adam Warren: Did anyone pick up a ...', time: '16:50', unread: true },
      { name: 'Michelle Halford', message: 'Looking forward to your participation!', time: '16:40', unread: true },
      { name: 'Linda Yan', message: 'Beer tasting, are you going?', time: '16:38', unread: true },
      { name: 'Kevin Wang', message: 'The event last week was quite interesting!', time: '15:30', unread: false },
      { name: 'Betty Dillenger', message: 'Are you home today?', time: '15:00', unread: false },
      { name: 'Ariel Larence', message: "I've been there before. It's interesting.", time: '12:30', unread: false }
    ] */

    return (
      <div className={styles['menu-panel']}>
        <h3 className={styles['menu-title']}>Chat</h3>
        {/* <div className={styles['menu-panel-content']}>
          {CHAT_COLLECTION.map((chat, index) => (
            <div key={`${chat.name.replace(' ', '')}_${index}`} className={styles['menu-chat-row']}>
              <div className={styles['menu-chat-avatar']}>
                <UserAvatarContainer user={{}} size={30} />
              </div>
              <div className={styles['menu-chat-name-message-box']}>
                <div className={styles['menu-chat-name-hour-row']}>
                  <p style={{ color: '#000000' }}>{chat.name}</p>
                  <p>{chat.time}</p>
                  <div className={styles['menu-chat-unread']} style={{ background: chat.unread ? 'red' : '#fff' }} />
                </div>
                <p>{chat.message}</p>
              </div>
            </div>
          ))}
        </div> */}
        <div className={styles['menu-panel-content']}>
          <div className={styles['download-app-container']}>
            <img src={emptyMessageModal} className={styles['download-app-image']} />
            <div className={styles['download-app-description']}>
              <h3>To Chat, Get the App</h3>
              <div>Hobnob makes group chats pain-free and private! Download Hobnob to direct message any guest on the guest list.</div>
            </div>
            <Button wrapperElement={'a'} href='https://go.hbnb.io/timepoll' target='_blank' className={styles['button']} >
              <span>Get hobnob to chat</span>
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default ChatPanel



// WEBPACK FOOTER //
// ./src/components/menu/panels/ChatPanel.jsx